<template>
  <div>
    <base-card>
      <base-question
        text="Esta categoria possui extras?"
        class="mb_25"
      />
      <base-radio
        label="Não"
        family="itemExtras"
        class="mb_15"
        :value="showExtraIngredientsArea"
        :option="false"
        @click="showExtraIngredientsArea = false"
      />
      <base-radio
        label="Sim"
        family="itemExtras"
        :value="showExtraIngredientsArea"
        :option="true"
        @click="showExtraIngredientsArea = true"
      />
    </base-card>
    <div v-if="showExtraIngredientsArea">
      <sized-list
        v-if="targetItem.sizes.length > 1 && targetItem.mode !== 'step'"
        title="Quais são os extras?"
        elementPlaceholder="Nome do extra"
        addButtonText="Adicionar extra"
        :deleteMode="deleteMode.extra_ingredients"
        :sizes="targetItem.sizes"
        :elements="targetItem.extra_ingredients.filter((e) => !e.delete)"
        @deleteMode="(activated) => (deleteMode.extra_ingredients = activated)"
        @removeElement="(e) => deleteItem(e._id, false)"
        @addNewItem="
          () => {
            (deleteMode.extra_ingredients = false), addExtraIngredient();
          }
        "
      />

      <div v-else>
        <base-card>
          <base-question text="Quais são os extras?" class="mb_25" />

          <div v-if="targetItem.extra_ingredients.length > 0">
            <div v-for="extra in targetItem.extra_ingredients" :key="extra._id">
              <div v-if="!extra.delete" class="extra-container">
                <base-input
                  label="Nome do extra"
                  v-model="extra.name"
                  :disabled="deleteMode.extra_ingredients"
                  class="mb_0 pr_5 pt_0 w-100 mr_10"
                  v-on:change="applyValue(extra._id, 'name', extra.name)"
                  :valid="isValidField('main', 'name')"
                />

                <base-input
                  :type="'tel'"
                  :money-mask="StringLanguage.currencyConfigs"
                  v-model="extra.price"
                  class="mb_0 pt_0 mr_10"
                  design="two"
                />

                <base-button
                  :text="StringLanguage.delete"
                  design="four"
                  @click.prevent="deleteItem(extra._id)"
                  class="delete-button"
                >
                  <i class="fal fa-times"></i>
                </base-button>
              </div>
            </div>
          </div>
          <div class="d-flex justify-end w-100 mt_25">
            <base-button
              text="Adicionar extra"
              design="two"
              @click.prevent="addExtraIngredient()"
              class="w-100 mr_5"
            />
          </div>
        </base-card>
      </div>
    </div>
  </div>
</template>

<script>
// components
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseRadio from "@/components/Radio";
import SizedList from "@/containers/Catalog/NewSizedList";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
// libs
import Vue from "vue";
import Builder from "easyjs/lib/Schema/Components/Builder";

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseRadio,
    SizedList,
    BaseInput,
    BaseButton
  },
  data() {
    return {
      deleteMode: {
        extra_ingredients: false,
      },
      showExtraIngredientsArea: this.targetItem.extra_ingredients.length > 0,
    };
  },
  props: {
    targetItem: { default: {} },
  },
  methods: {
    addExtraIngredient() {
      if (
        this.targetItem.mode == "simple" ||
        this.targetItem.sizes.filter((i) => !i.delete).length > 0
      ) {
        this.addNewItem("Extraingredient", this.targetItem._id);
        this.updateExtras();
      } else {
        alert("Você precisa cadastrar algum tamanho antes.");
      }
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    updateExtras() {
      this.targetItem.extra_ingredients.forEach((e) => {
        let extraSizes = e.sizes.reduce(
          (obj, size) => ({ ...obj, [size._id]: size }),
          {}
        );
        e.sizes = this.targetItem.sizes
          .map((s) => {
            return extraSizes[s._id] || Builder.mountSchema(Object.clone(s));
          })
          .filter((s) => !s.delete);
      });
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam("_id", id)
            .forEach((i) => Vue.set(i, "delete", true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory("Catalog");
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, (item) => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                "sizes",
                item.sizes.filter((s) => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, (res) => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit("saveItem", this.targetItem);
      }
    },
    applyValue(sizeId, attr, max) {},
    isValidField(key, value) {},
  },
};
</script>

<style scoped>
.extra-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}
.delete-button {
  height: 45px;
  margin-left: 5px;
  border-color: #99999980;
}
.delete-button i {
  font-size: 16px;
}
</style>